import { Link } from 'react-router-dom';

// material-ui
import { Grid, Stack, Typography } from '@mui/material';

// project import
import BaseWrapper from './BaseWrapper';

// Icon

// ================================|| LOGIN ||================================ //

const NotFoundPage = () => (
  <BaseWrapper>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <img src="@public/assets/images/icons/no-data-icons/delivery-truck.svg" height={250} width={250} alt="not-found" />
        <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
          <Typography variant="h3">Something Went Wrong</Typography>
          <Typography component={Link} to="/dashboard/default" variant="body1" sx={{ textDecoration: 'none' }} color="primary">
            Back to home page?
          </Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5">Oops! The Page you reuqested does not exist</Typography>
      </Grid>
    </Grid>
  </BaseWrapper>
);

export default NotFoundPage;
